export default __webpack_public_path__ + "assets/transcription_signal_indicator.png";